import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Combien de temps dure la formation ?',
      answer: 'La formation se déroule sur 4 semaines avec un rythme progressif et adapté. Vous aurez accès à 1 module par semaine (environ 1h30 de contenu) + des exercices pratiques à réaliser à votre rythme. L\'accès à la plateforme reste ouvert à vie, vous pouvez donc avancer selon vos disponibilités et revenir sur les contenus quand vous le souhaitez.'
    },
    {
      question: 'Dois-je avoir des connaissances en sophrologie pour suivre cette formation ?',
      answer: 'Non, absolument pas ! Cette formation est conçue pour être accessible à tous, que vous soyez cavalière débutante en sophrologie ou professionnelle souhaitant vous spécialiser. Tous les concepts sont expliqués de manière claire et progressive, avec des démonstrations pratiques adaptées au monde équestre.'
    },
    {
      question: 'Puis-je suivre la formation si je ne monte plus à cheval actuellement à cause de la douleur ?',
      answer: 'Oui, c\'est même l\'un des objectifs principaux de cette formation ! Beaucoup de cavalières ont dû arrêter ou réduire leur pratique à cause de l\'endométriose. Cette formation vous donnera les outils pour gérer la douleur et reprendre progressivement l\'équitation dans de meilleures conditions. Vous pourrez pratiquer les exercices même sans monter, puis les appliquer progressivement à cheval.'
    },
    {
      question: 'La formation est-elle adaptée à tous les niveaux équestres ?',
      answer: 'Oui ! Que vous pratiquiez le loisir, la compétition, la dressage, le CSO, l\'endurance ou toute autre discipline, les techniques enseignées sont universelles et s\'adaptent à votre pratique. Les protocoles de gestion de la douleur et de relâchement fonctionnent quel que soit votre niveau ou votre discipline équestre.'
    },
    {
      question: 'Vais-je recevoir un certificat à la fin de la formation ?',
      answer: 'Oui ! À l\'issue de la formation, vous recevrez un certificat de formation professionnelle "Sophrologie et Endométriose pour Cavalières". Ce certificat atteste de vos compétences et peut être valorisé si vous souhaitez accompagner d\'autres cavalières (en complément de vos qualifications existantes en sophrologie ou coaching).'
    },
    {
      question: 'Que se passe-t-il si je ne suis pas satisfaite de la formation ?',
      answer: 'Nous offrons une garantie satisfait ou remboursé de 30 jours. Si après avoir suivi les premiers modules, vous estimez que la formation ne correspond pas à vos attentes, vous pouvez demander un remboursement intégral sans justification. Votre satisfaction est notre priorité.'
    },
    {
      question: 'Y a-t-il un accompagnement pendant la formation ?',
      answer: 'Oui ! Vous bénéficierez d\'un accompagnement personnalisé et illimité par la fondatrice pendant toute la durée de la formation et même après. Vous pourrez poser vos questions, partager vos difficultés et recevoir des conseils adaptés à votre situation personnelle. Cet accompagnement individuel vous garantit un suivi sur-mesure pour optimiser vos résultats et progresser à votre rythme.'
    },
    {
      question: 'Puis-je utiliser ces techniques pour accompagner d\'autres cavalières professionnellement ?',
      answer: 'Oui, si vous êtes déjà sophrologue, coach, préparateur mental ou professionnel de l\'accompagnement. Cette formation vous donne une spécialisation unique sur l\'endométriose et l\'équitation. Vous recevrez des protocoles clés en main, des fiches pratiques et des outils pour accompagner vos clientes cavalières de manière professionnelle et efficace.'
    },
    {
      question: 'Les techniques fonctionnent-elles vraiment pour réduire la douleur ?',
      answer: 'Les techniques de sophrologie pour la gestion de la douleur chronique sont reconnues et validées scientifiquement. De nombreuses études montrent une réduction significative de la douleur (40-70%) chez les femmes atteintes d\'endométriose qui pratiquent régulièrement. Cette formation adapte ces protocoles spécifiquement à la pratique équestre, avec des résultats concrets observés chez nos cavalières.'
    },
    {
      question: 'Quel est le format de la formation ?',
      answer: 'La formation est 100% en ligne et accessible depuis n\'importe quel appareil (ordinateur, tablette, smartphone). Vous aurez accès à des vidéos de cours, des audios de protocoles guidés, des fiches pratiques téléchargeables, et des exercices à réaliser à votre rythme. Le contenu est structuré de manière progressive pour un apprentissage optimal.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        {/* En-tête */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#E8956F]/10 px-4 py-2 rounded-full mb-6">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-question-answer-line text-[#E8956F] text-base"></i>
            </div>
            <span className="text-sm font-medium text-[#3D2817]">Questions fréquentes</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-[#3D2817] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Vos questions, nos réponses
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Tout ce que vous devez savoir avant de vous lancer dans cette formation
          </p>
        </div>

        {/* Liste FAQ */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-[#FAF7F4] rounded-2xl overflow-hidden border border-gray-100 hover:border-[#E8956F]/30 transition-all"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left cursor-pointer hover:bg-[#F5F0EB] transition-colors"
              >
                <span className="text-lg font-semibold text-[#3D2817] flex-1" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  {faq.question}
                </span>
                <div className={`w-8 h-8 flex items-center justify-center rounded-full bg-[#E8956F]/10 transition-transform ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-[#E8956F] text-xl"></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">Vous avez d'autres questions ?</p>
          <a 
            href="mailto:sophro.cavaliers@gmail.com"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white text-[#3D2817] rounded-full text-base font-medium hover:bg-gray-50 transition-all border-2 border-[#3D2817] whitespace-nowrap cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-mail-line text-base"></i>
            </div>
            <span>Contactez-nous</span>
          </a>
        </div>
      </div>
    </section>
  );
}
